export const API_URL =
  import.meta.env.VITE_API_URL || 'http://localhost:3000/api';
export const API_KEY = import.meta.env.VITE_API_KEY || 'dev';
export const MEDIA_URL =
  import.meta.env.VITE_MEDIA_URL || 'http://127.0.0.1:2731';
export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL ||
  (import.meta.env.DEV ? 'http://localhost:3000' : 'wss://api.scl.gg');
export const API_VERSION = 'v1';
export const FACEIT_API_URL = 'https://open.faceit.com/data/v4';
export const SITE_KEY = '6Le4EgkqAAAAABpBAdLV_P1caS-Gov85Ca3MQqLW';
